<template>
    <form @submit.prevent="save">
      <v-alert type="info" :value="!!offering.id">
        Making changes to this product will not change any current subscriptions.
      </v-alert>
      <h-input type="text" label="Name" v-model="offering.title" required />
      <div class="input">
        <h-input :reverse="true" type="checkbox" label="Active" v-model="offering.active" />
      </div>
      <h-select :items="subDomains" label="Subdomain" item-text='sub_domain' item-value='id' v-model='offering.sub_domain' v-if="subDomains.length > 1" />
      <h-select :items="coaches"
                item-text="full_name"
                item-value="coach_profile"
                label="Coach"
                v-model="offering.coach_profile"
                :disabled="coaches.length == 1"
                v-if="coaches.length > 1"
                required
                ></h-select>
      <client-profile-form :profile="offering" @error="val => { profileError = val }"/>
      <h-select :items="habitPrograms"
                label="Habit Program"
                item-text="name"
                item-value="id"
                v-model="offering.habit_program"
                v-if="offering.allow_daily_exercises"
                required></h-select>
      <h-select :items="pulseSurveys"
                label="Daily Reflection"
                v-if="offering.allow_self_reflect"
                item-text="name"
                item-value="id"
                v-model="offering.pulse_survey"
                required></h-select>
      <h3 class="small-top" v-if="courses.length > 0 && offering.allow_courses">Courses</h3>
      <div v-if=" offering.allow_courses" class="content courses">
        <div v-for="course in courses" :key="course.id">
          <input type="checkbox"
            :id="course.id"
            v-model="offering.courses"
            :value="course.id"
            />
            <label>{{course.title}}</label>
        </div>
      </div>
      <h-input 
        type="number"
        v-model="offering.price"
        label="Monthly Subscription Cost (in cents)"
        />
      <div class="card card--transparent small-top" style="margin-top: '30px'" 
        v-if="!company.allow_paid_subscriptions">
        <div class="card--container">
          You cannot charge for subscriptions currently. Please, go into site settings
          and link with Stripe to charge clients.
        </div>
      </div>
      <div class="card card--transparent small-top" style="margin-top: '30px'" v-if='offering.active && offering.id'>
        <div class="card--container">
          <div>New clients can sign up at:</div> 
          <a :href="offering.link">{{offering.link}}</a>
        </div>
      </div>
      <v-alert type="error" :value="errors.length !== 0">
        <div v-for="error in errors" :key="error">{{error}}</div>
      </v-alert>
      <h-btn class="small-top full-width" color="primary" type="submit" :disabled="loading || profileError">Save</h-btn>
    </form>
</template>

<script>
import snackbar from "@/services/hubs/snackbar";
import store from "@/services/api/store";
import clientProfileForm from "../components/clients/clientProfileForm";

const CLIENT_OFFERINGS_STORE = 'OwnerClientOfferings';



export default {
  components: { clientProfileForm },
  props: {
    habitPrograms: {
      type: Array,
      default: () => []
    },
    coaches: {
      type: Array,
      default: () => []
    },
    pulseSurveys: {
      type: Array,
      default: () => []
    },
    courses: {
      type: Array,
      default: () => []
    },
    offering: {
      type: Object,
      default: () => {
        return {
          promo: "",
          home: "daily_exercises",
          allow_daily_exercises: true,
          allow_self_reflect: true,
          allow_goals: true,
          allow_progress: true,
          allow_courses: true,
          allow_journal: true,
          allow_assessments: true,
          allow_messaging: true
          // default: false
        };
      }
    },
    subDomains: {
      type: Array,
      default: () => []
    },
    company: {
      type: Object,
      default: () => {
        return { sub_domain: "" }
      }
    }
  },
  data() {
    return {
      active: false,
      loading: false,
      errors: [],
      profileError: false
    };
  },
  computed: {
    fullSiteUrl() {
      return this.offering.link;
    },
    disallowPriceChange() {
      return !!this.originalPrice || !!this.allow_paid_subscriptions
    }
  },
  created() {
    this.originalPrice = this.offering.price;
  },
  methods: {
    valid() {
      this.errors = [];
      if (this.offering.daily_exercises && !this.offering.habit_program) {
        this.errors.push("A Habit Program is required");
      }
      if (this.offering.self_reflect && !this.offering.pulse_survey) {
        this.errors.push("A Daily Reflection is required");
      }
      if (!this.offering.coach_profile) {
        this.errors.push("A Coach is required");
      }
      return this.errors.length === 0;
    },
    save() {
      if (!this.valid()) {
        return;
      }

      this.loading = true;
      let promise;
      if (this.offering.id) {
        promise = store.update(CLIENT_OFFERINGS_STORE, this.offering.id, this.offering);
      } else {
        this.offering.company = this.company.id;
        promise = store
          .create(CLIENT_OFFERINGS_STORE, this.offering)
          .then(r => {
            this.offering.id = r.id;
            return r;
          });
      }

      promise
        .then((offering) => {
          snackbar.update("Saved");
          this.$emit('saved', offering);
        }).catch(({response}) => {
          if (response.status >= 500) {
            this.errors.push("There was a server error. Our staff has been notified, and is looking into it. Please try again later.")
          } else {
            let { data } = response;
            if (data.non_field_errors) {
              this.errors = data.non_field_errors;
            } else {
              this.errors = data;
            }
          }
        })
        .finally(() => (this.loading = false));
    }
  },
};
</script>

<style lang="less" scoped>
.owner-client-offering {
  a {
    color: white;
    font-weight: 500;
  }
}
.courses {
  flex-direction: row;
  align-items: center;
  text-transform: capitalize;
  input {
    margin-right: 5px;
  }
}
</style>
